module.exports = __webpack_public_path__ + "media/icons/document-folded-44ef2720.png";